/* =====================================================
   LUNALY HEADER JS — assets/lunaly-header.js
   ===================================================== */
(function () {
  'use strict';

  var ANNOUNCE_TOP     = 0;
  var GLASS_TOP        = 6;   /* px from top of screen when in glass mode */
  var ANNOUNCE_GAP     = 6;
  var BOTTOM_GAP       = 14;
  var SCROLL_THRESHOLD = 10;
  var ANNOUNCE_H       = 34; /* must match --lly-full-h in CSS */

  var announce      = document.getElementById('lly-announce');
  var header        = document.getElementById('lly-header');
  var burger        = document.getElementById('lly-burger');
  var drawer        = document.getElementById('lly-drawer');
  var drawerClose   = document.getElementById('lly-drawer-close');
  var searchBtn     = document.getElementById('lly-search-btn');
  var searchClose   = document.getElementById('lly-search-close');
  var searchOverlay = document.getElementById('lly-search-overlay');
  var searchInput   = document.getElementById('lly-search-input');
  var overlay       = document.getElementById('lly-overlay');
  var cartCount     = document.getElementById('lly-cart-count');

  /* ── Badge parser ─────────────────────────────
     Name nav links "Title [BADGE]" in Shopify admin
  ─────────────────────────────────────────────── */
  function parseBadges() {
    var links = document.querySelectorAll('#lly-nav a, #lly-drawer a');
    links.forEach(function (a) {
      var m = a.textContent.trim().match(/^(.*?)\s*\[(.+?)\]$/);
      if (m) {
        a.innerHTML = m[1].trim() + ' <span class="lly-badge">' + m[2].trim() + '</span>';
      }
    });
  }

  /* ── Position helpers ─────────────────────────── */
  function defaultHeaderTop() {
    return ANNOUNCE_TOP + ANNOUNCE_H + ANNOUNCE_GAP;
  }

  function setHeaderTop(px) {
    if (header) header.style.top = px + 'px';
  }

  function setBodyPadding() {
    if (!header) return;
    document.body.style.paddingTop =
      (defaultHeaderTop() + header.offsetHeight + BOTTOM_GAP) + 'px';
  }

  /* ── Scroll state ─────────────────────────────── */
  var isGlass = false;
  var raf     = false;

  function onScroll() {
    if (!raf) { raf = true; requestAnimationFrame(updateScroll); }
  }

  function updateScroll() {
    var scrollY = window.scrollY || window.pageYOffset || 0;
    var shouldGlass = scrollY > SCROLL_THRESHOLD;
    if (shouldGlass !== isGlass) {
      isGlass = shouldGlass;
      applyState(shouldGlass);
    }
    raf = false;
  }

  function applyState(glass) {
    if (!header) return;
    if (glass) {
      if (announce) announce.classList.add('lly-hidden');
      setHeaderTop(GLASS_TOP);
      header.classList.add('lly-glass');
    } else {
      /* Set header to final position BEFORE announcement expands
         so there is never any overlap during the transition.    */
      setHeaderTop(defaultHeaderTop());
      header.classList.remove('lly-glass');
      if (announce) announce.classList.remove('lly-hidden');
    }
  }

  /* ── Mobile drawer ────────────────────────────── */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('lly-open');
    if (overlay) overlay.classList.add('lly-show');
    if (burger)  burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('lly-locked');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('lly-open');
    if (overlay) overlay.classList.remove('lly-show');
    if (burger)  burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('lly-locked');
  }

  /* ── Search overlay ───────────────────────────── */
  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('lly-open');
    document.body.classList.add('lly-locked');
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 60);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('lly-open');
    document.body.classList.remove('lly-locked');
  }

  /* ── Cart count ───────────────────────────────── */
  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!cartCount) return;
        var n = data.item_count || 0;
        cartCount.textContent = n;
        cartCount.style.display = n > 0 ? 'flex' : 'none';
      })
      .catch(function () {});
  }

  /* ── Events ───────────────────────────────────── */
  function bind() {
    window.addEventListener('scroll', onScroll, { passive: true });
    if (burger)      burger.addEventListener('click', openDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (overlay)     overlay.addEventListener('click', closeDrawer);
    if (searchBtn)   searchBtn.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeDrawer(); closeSearch();
    });
    document.addEventListener('cart:updated', refreshCart);
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!isGlass) setHeaderTop(defaultHeaderTop());
        setBodyPadding();
      }, 120);
    });
  }

  /* ── Init ─────────────────────────────────────── */
  function init() {
    parseBadges();
    setHeaderTop(defaultHeaderTop());
    setBodyPadding();
    bind();
    updateScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
